/* LOFTY TCG — Límite 1 unidad por persona (capa UX) */
/* La protección real del submit está en product-form.js */
/* Solo aplica a producto SELLADO (data-lofty-sealed) con precio MAYOR a $1,200 MXN; singles sin límite */
(function() {
  'use strict';

  var LOFTY_LIMIT_THRESHOLD_CENTS = 120000;
  var LOFTY_MAX_QTY = 1;

  function getProductPriceCents(form) {
    if (!form || !form.dataset) return 0;
    var price = parseInt(form.dataset.productPriceCents, 10);
    return isNaN(price) ? 0 : price;
  }

  function clamp(input) {
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    if (v > LOFTY_MAX_QTY) v = LOFTY_MAX_QTY;
    input.value = String(v);
  }

  function capQuantity(input, plus) {
    if (!input || input.dataset.loftyLocked === '1') return;
    input.min = '1';
    input.max = String(LOFTY_MAX_QTY);
    input.setAttribute('data-max', String(LOFTY_MAX_QTY));
    clamp(input);
    input.dataset.loftyLocked = '1';
    var onChange = function() {
      clamp(input);
      if (plus) plus.classList.toggle('disabled', parseInt(input.value, 10) >= LOFTY_MAX_QTY);
    };
    input.addEventListener('input', onChange);
    input.addEventListener('change', onChange);
    onChange();
  }

  function injectLimitMessage(qi) {
    if (!qi || qi.dataset.loftyMsgInjected === '1') return;
    var msg = document.createElement('p');
    msg.className = 'lofty-limit-msg';
    msg.style.cssText = 'font-size:0.85em; color:var(--lofty-accent, #2BB58A); margin-top:0.5em; margin-bottom:0; font-weight:500;';
    msg.textContent = 'Límite: 1 unidad por persona';
    qi.parentNode.insertBefore(msg, qi.nextSibling);
    qi.dataset.loftyMsgInjected = '1';
  }

  function applyLimitToForm(form) {
    if (!form || form.dataset.loftyProcessed === '1') return;

    var priceCents = getProductPriceCents(form);
    if (form.dataset.loftySealed !== 'true' || priceCents <= LOFTY_LIMIT_THRESHOLD_CENTS) {
      form.dataset.loftyProcessed = 'skip';
      return;
    }

    var qi = form.querySelector('quantity-input');
    if (!qi) {
      var info = form.closest('product-info');
      if (info) qi = info.querySelector('quantity-input');
    }

    if (qi) {
      var input = qi.querySelector('input[name="quantity"]');
      var plus = qi.querySelector('button[name="plus"]');
      if (input) capQuantity(input, plus);
      injectLimitMessage(qi);
    }

    form.dataset.loftyProcessed = 'applied';
  }

  function applyAll() {
    var forms = document.querySelectorAll('product-form');
    forms.forEach(applyLimitToForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  var obs = new MutationObserver(function(mutations) {
    var needsCheck = false;
    mutations.forEach(function(m) {
      if (m.addedNodes && m.addedNodes.length > 0) {
        for (var i = 0; i < m.addedNodes.length; i++) {
          var node = m.addedNodes[i];
          if (node.nodeType === 1 && (node.tagName === 'PRODUCT-FORM' || node.querySelector && node.querySelector('product-form'))) {
            needsCheck = true;
            break;
          }
        }
      }
    });
    if (needsCheck) applyAll();
  });
  obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
